export default __webpack_public_path__ + "static/media/18.f7a06de4.png";